import React from 'react';
import { CollapsibleLinkpile } from '@homeaway/react-linkpile';

import './SeoLinkpile.less';

const SeoLinkPile = props => <CollapsibleLinkpile forceExpanded {...props}/>;

export default SeoLinkPile;
